import { useContext, React, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import InputComponent from "../../../../components/InputComponent/InputComponent";
import ContentData from "../../../../constants/contentFile.json";
import "./addAdmin.css";
import { AddAdminContext } from "../AddAdminView";
import NextIcon from "../../../../assets/images/next-icon.svg";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import Loader from "../../../../components/Loader/Loader";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import ThemeSelect from "../../../../components/ThemeSelectOption/SelectOption";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import ToggleArrow from "../../../../assets/images/Toggle-arrow.svg";

const AddAdminPage = () => {
  const {
    spinnerStatus,
    roleList,
    handleRoleChange,
    roleCategotyValidate,
    role,
    roleListShown,
    emailValidationMsg,
    addAdminformValidation,
    handleName,
    name,
    nameValidation,
    handleEmailChange,
    email,
    validatedName,
    successAlertMessage,
    adminUserList,
    successAlertShow,
    errorAlertMessage,
    adminUserAdd,
    errorAlertShow,
    setErrorAlertShow,
    statusValue,
    buttonText,
    adminToLogin,
    handleEmailBlur,
    permissionAccess,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
  } = useContext(AddAdminContext);

  useEffect(() => {
    roleListShown();
  }, []);

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={adminUserList}>
          {ContentData.adminPage.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">{ContentData.adminPage.addAdmin}</span>
      </div>
      {spinnerStatus && <Loader />}
      <Container>
        <button type="button" onClick={adminUserList} class="navbar-btn">
          <img src={ToggleArrow} alt="toggle-arrow" />
        </button>
        <div className="pageTittles">{ContentData.adminPage.addAdmin}</div>
        <form className="adminUserSection" onSubmit={addAdminformValidation}>
          <div className="basicContainer">
            <div className="viewAdminSection addAdminSection">
              <Row>
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.adminPage.fullName} *</h4>
                      <InputComponent
                        placeholder={ContentData.adminPage.fullEnter}
                        value={name}
                        type={"text"}
                        onChange={handleName}
                        handleBlur={() => nameValidation(name)}
                      />
                      <p className="mb-0 error-msg">
                        {validatedName ? validatedName : ""}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.adminPage.emailaddress} *</h4>
                      <InputComponent
                        placeholder={ContentData.authPage.emailPlaceholder}
                        value={email}
                        onChange={handleEmailChange}
                        handleBlur={handleEmailBlur}
                      />
                      <p className="mb-0 error-msg">
                        {emailValidationMsg ? emailValidationMsg : ""}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.adminPage.role} *</h4>
                      <ThemeSelect
                        selectPlaceholder={"Select"}
                        values={roleList}
                        selectNum={"_id"}
                        label={"name"}
                        handleSelectData={handleRoleChange}
                        defaultValue={role}
                      />
                      <p className="mb-0 error-msg">
                        {roleCategotyValidate ? roleCategotyValidate : ""}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="bottomButtons">
            <BorderButton
              value={ContentData.authPage.cancelText}
              onClick={adminUserList}
            />
            <ThemeButton
              value={ContentData.authPage.submitText}
              id="submitAddEditBtn"
              type="submit"
            />
          </div>
        </form>
        <PopupAlertError
          status={statusValue}
          show={errorPopup}
          alertMessage={errorPopupMessage}
          buttonText={buttonText}
          handleCancel={() => setErrorPopup(false)}
          handleSubmit={() => {
            if (statusValue === 401) {
              adminToLogin();
              setErrorPopup(false);
            } else {
              setErrorPopup(false);
              document.getElementById("submitAddEditBtn").click();
            }
          }}
          errorAlertOnly={statusValue === 400 ? true : false}
        />
        <SuccessPopupAlert
          show={successAlertShow}
          alertMessage={successAlertMessage}
          handleSubmit={() => adminUserList()}
        />
      </Container>
    </div>
  );
};

export default AddAdminPage;
